import React, { ReactNode, HTMLProps } from 'react'
import classnames from 'classnames'
import { makeStyles, createStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'

export interface IPillBoldTextProps extends HTMLProps<HTMLElement> {
  children: ReactNode
  facet?: boolean
  applied?: boolean
}

const usePillBoldTextStyles = makeStyles(() =>
  createStyles<string, Omit<IPillBoldTextProps, 'children' | 'className'>>({
    pillBoldText: {
      color: ({ applied, facet }: Pick<IPillBoldTextProps, 'applied' | 'facet'>) => {
        if (applied && facet) {
          return brandColors.skyBlue7
        }

        if (applied) {
          return brandColors.coolGray8
        }

        return 'auto'
      },
    },
  })
)

export const PillBoldText = ({ children, className, ...props }: IPillBoldTextProps) => {
  const styles = usePillBoldTextStyles(props)
  const containerClasses = classnames(styles.pillBoldText, className)

  return (
    <b className={containerClasses} {...props}>
      {children}
    </b>
  )
}

export default PillBoldText
